import React from 'react';
import { useNavigate } from 'react-router-dom';

const IdeaChoice: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 relative overflow-hidden min-h-screen flex items-center justify-center">
      {/* Background with gradient and mesh */}
      <div className="absolute inset-0 bg-gray-50 z-0">
        <div className="absolute inset-0 opacity-30 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgdmlld0JveD0iMCAwIDYwIDYwIiBmaWxsPSJub25lIj48cGF0aCBkPSJNLjUuNWg2MHY2MEguNVYuNXptMzAgMTVhMTUgMTUgMCAwIDAtMTUgMTUgMTUgMTUgMCAwIDAgMTUgMTUgMTUgMTUgMCAwIDAgMTUtMTUgMTUgMTUgMCAwIDAtMTUtMTV6bTAgMGExNSAxNSAwIDAgMC0xNSAxNSAxNSAxNSAwIDAgMCAxNSAxNSAxNSAxNSAwIDAgMCAxNS0xNSAxNSAxNSAwIDAgMC0xNS0xNXoiIHN0cm9rZT0iIzIwMjAyMCIgc3Ryb2tlLW9wYWNpdHk9Ii4wNiIvPjwvc3ZnPg=='))] bg-[size:50px_50px]"></div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 -left-12 w-64 h-64 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
      <div className="absolute bottom-20 -right-12 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob animation-delay-2000"></div>

      <div className="container relative z-10 mx-auto px-4 flex flex-col items-center">
        {/* Section Title with 3D effect */}
        <div className="relative mb-10 text-center">
          <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 inline-block">
            How would you like to start?
          </h1>
          <div className="h-1 w-40 mx-auto rounded-full bg-gradient-to-r from-blue-400 to-purple-500 mt-2"></div>
        </div>

        <div className="flex flex-col md:flex-row gap-6 w-full max-w-2xl">
          <button
            onClick={() => navigate('/idea-generator')}
            className="flex-1 px-6 py-8 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl shadow-lg hover:shadow-blue-500/30 text-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 backdrop-blur-sm relative overflow-hidden group"
          >
            <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
            <div className="relative z-10">Create Idea from Your Skills</div>
          </button>
          <button
            onClick={() => navigate('/add-idea')}
            className="flex-1 px-6 py-8 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-xl shadow-lg hover:shadow-green-500/30 text-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 backdrop-blur-sm relative overflow-hidden group"
          >
            <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
            <div className="relative z-10">Save Your Own Idea</div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default IdeaChoice;
